export default __webpack_public_path__ + "6bc916b001f09e6b64e52e8aa2ba656c.png";